import React, { Component } from 'react'
import './DropDown.css'

export default class DropDown extends Component {
    constructor() {
        super()
        this.state = {
            expanded: false
        }
    }

    selectNewItemHandler = (newSelection) => {
        this.setState({ expanded: false })
        this.props.changeOption(newSelection)
    }

    getDropDownWidthHandler = () => {
        let props = this.props
        if (props.items.length <= 6 || (props.items.length === 7 && props.itemSelected !== -1)) {
            return props.width - 40
        } else {
            return props.width - 23
        }
    }

    render() {
        return (
            <div className={`adminDropDownContainer ${this.props.customClass ? this.props.customClass : ''}`} style={{ width: `${this.props.width}px` }} onClick={(e) => {e.stopPropagation(); this.setState({ expanded: !this.state.expanded })}} onBlur={this.state.expanded ? () => this.setState({ expanded: !this.state.expanded }) : null}>
                <div className='dropDownBody'>
                    <p className='dropDownBodyText'>{this.props.items[this.props.itemSelected]}</p>
                </div>
                <div className='dropDownArrowContainer'>
                    <p className='dropDownArrow'></p>
                </div>
                <div className={`dropDownListOfItemsContainer ${this.state.expanded ? '' : 'dropDownListOfItemsHidden'}`} style={{ width: `${this.getDropDownWidthHandler()}px` }}>
                    {this.props.items.map((value, index) => (
                        index !== this.props.itemSelected ?
                            <div className='dropDownListOfItemsItem' key={index} onClick={(e) => {e.stopPropagation(); this.selectNewItemHandler(index)}}>
                                <p className='dropDownListOfItemsText'>{value}</p>
                            </div> :
                            null
                    ))}
                </div>
            </div >
        )
    }
}
